// src/sdk/OmegaWsService.ts
import { OmegaWsClient } from '@kabco/omega-ws';
import { AuthApi } from '@/app/data/auth/AuthApi';
import { TelegramAuthController } from '@/app/shared/auth/TelegramAuthController';
import { ProfileViewModel } from '@/app/core/tockensPaymentLogic/ProfileViewModel';

export class OmegaWsService {
  private static _instance: OmegaWsService;
  private client: OmegaWsClient | null = null;

  static getInstance(): OmegaWsService {
    if (!OmegaWsService._instance) {
      OmegaWsService._instance = new OmegaWsService();
    }
    return OmegaWsService._instance;
  }

  getOrCreateClient(): OmegaWsClient {
    if (!this.client) {
      this.client = new OmegaWsClient({
        url: 'wss://gpt-bot.kabco.tech/ws',
        accessToken: () => AuthApi.getAccessToken() || '',
        onTokens: (tokens: { accessToken: string; refreshToken?: string }) => {
          AuthApi.saveTokens(tokens);
          const tgUser = (window as any).Telegram?.WebApp?.initDataUnsafe?.user;
          if (tgUser) {
            TelegramAuthController.getInstance().setUser(tgUser);
            ProfileViewModel.getInstance().loadAll().catch(() => {});
          }
        },
        // reconnect и heartbeat включены в SDK по умолчанию.
        // Не выключать: иначе reconnected / agent.open после обрыва не работают.
      });
    }
    return this.client;
  }

  getClient(): OmegaWsClient | null {
    return this.client;
  }

  async connect(initData?: string): Promise<void> {
    const client = this.getOrCreateClient();
    // Сбрасываем старые токены, чтобы начать новую сессию
    AuthApi.clearTokens();
    await client.connect(initData ? { initData, readyTimeoutMs: 60_000 } : { readyTimeoutMs: 60_000 });
  }

  async reconnect(): Promise<void> {
    if (this.client) {
      await this.client.reconnect();
    }
  }

  disconnect(): void {
    if (this.client) {
      this.client.disconnect();
    }
  }

  destroy(): void {
    if (this.client) {
      this.client.destroy();
      this.client = null;
    }
  }

  /**
   * Logout: чистка токенов + полное уничтожение клиента.
   * По доке: destroy() — единственный корректный способ при выходе.
   */
  logout(): void {
    AuthApi.clearTokens();
    this.destroy();
  }

  getStatus() {
    return this.client?.getStatus() ?? 'idle';
  }
}